import { useEffect } from 'react';
import { useUuiContext } from '@epam/uui-core';
import * as amplitude from '@amplitude/analytics-browser';
import { AMPLITUDE_API_KEY } from '../constants';
import { amplSetUserProperty } from '../utils';
const analyticsListener = {
    sendEvent: (event, parameters, eventType) => {
        if (!event || eventType !== 'event')
            return;
        amplitude.logEvent(event.name, parameters);
    },
};
export const useAnalytics = (user, debug = false, optOut = false) => {
    const { uuiAnalytics } = useUuiContext();
    useEffect(() => {
        if (!user)
            return;
        const trackingDisabled = optOut || !AMPLITUDE_API_KEY || (user.isPlatformDeveloper && !debug);
        amplitude.init(AMPLITUDE_API_KEY, user.userIdHash, {
            defaultTracking: true,
            optOut: trackingDisabled,
            identityStorage: 'localStorage',
        });
        amplSetUserProperty('user_country', user.userCountryCode);
        uuiAnalytics.addListener(analyticsListener);
    }, [user]);
};
